/**
 * Class description
 *
 * Created: 2017-10-09
 * @author jonas
 */
import {ILayerConfig, ILayersConfig} from "@nolimitcity/slot-game/bin/core/stage/ILayersConfig";
import {
    CustomLayerScaleOptions,
    LayerScaleOption,
    ScaleMethod,
    ScaleTarget
} from "@nolimitcity/slot-game/bin/core/stage/LayerScaleOption";
import {IDeviceDependentConfig} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";


export class DungeonQuestLayerConfig {

    public static defaultLayerScaleOptions:IDeviceDependentConfig<LayerScaleOption> = {
        desktop : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_STAGE
        },
        mobile : {
            landscape : LayerScaleOption.REELS_FIT_STAGE,
            portrait : LayerScaleOption.REELS_FIT_STAGE
        }
    };

    public static bottomPlacement:CustomLayerScaleOptions = {
        placement : {x : 0.5, y : 1}
    };

    public static reelBackground:CustomLayerScaleOptions = {
        target : {
            desktop : {
                landscape : ScaleTarget.STAGE
            },
            mobile : {
                landscape : ScaleTarget.STAGE,
                portrait : ScaleTarget.WINDOW
            }
        },
        placement : {
            desktop : {
                landscape : {x : 0.5, y : 1}
            },
            mobile : {
                landscape : {x : 0.5, y : 1},
                portrait : {x : 0.5, y : 1}
            }
        },
        method : {
            desktop : {
                landscape : ScaleMethod.FIT
            },
            mobile : {
                landscape : ScaleMethod.FIT,
                portrait : ScaleMethod.FIT
            }
        }

    };

    public static introConfig:CustomLayerScaleOptions = {
        target : ScaleTarget.WINDOW,
        method : ScaleMethod.FIT,
        frame : {x : 0, y : 0, width : 720, height : 720},
        placement : {x : 0.5, y : 0.5}
    };


    public static BACKGROUND:ILayerConfig = {name : "background", scaleOption : LayerScaleOption.FILL_WINDOW};

    public static REEL_BACKGROUND:ILayerConfig = {
        name : "reel_background",
        customOptions : DungeonQuestLayerConfig.reelBackground
    };
    public static DARKEN_PLATE:ILayerConfig = {
        name : "darken_plate",
        customOptions : DungeonQuestLayerConfig.reelBackground
    };
    public static NEAR_WIN_DIV_ATTENTIONS:ILayerConfig = {
        name : "near_win_div_attentions",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static REEL_ATTENTIONS:ILayerConfig = {
        name : "reel_attentions",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static REEL_FOREGROUND:ILayerConfig = {
        name : "reel_foreground",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static BET_LINES:ILayerConfig = {
        name : "bet_lines",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static SYMBOLS:ILayerConfig = {
        name : "symbols",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static BIG_SYMBOLS:ILayerConfig = {
        name : "big_symbols",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static SYMBOLS_OVERLAY:ILayerConfig = {
        name : "symbols_overlay",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static LOGO_LAYER:ILayerConfig = {
        name : "logo_layer",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static WIN_DISPLAY:ILayerConfig = {
        name : "win_display",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static RANDOM_WILD_LAYER:ILayerConfig = {
        name : "random_wild_layer",
        customOptions : DungeonQuestLayerConfig.reelBackground
    };

    public static RANDOM_FEATURE_INTRO:ILayerConfig = {
        name : "random_feature_intro",
        customOptions : DungeonQuestLayerConfig.reelBackground
    };

    public static PARTICLES_BOTTOM:ILayerConfig = {
        name : "particles_bottom",
        customOptions : DungeonQuestLayerConfig.reelBackground
    };
    public static PARTICLES_TOP:ILayerConfig = {
        name : "particles_top",
        customOptions : DungeonQuestLayerConfig.reelBackground
    };
    public static BIG_WIN:ILayerConfig = {
        name : "bigWin",
        customOptions : DungeonQuestLayerConfig.bottomPlacement
    };
    public static DEBUG_OVERLAY:ILayerConfig = {name : "debug_overlay", scaleOption : LayerScaleOption.NONE};

    public static INTRO:ILayerConfig = {name : "intro", customOptions : DungeonQuestLayerConfig.introConfig};


    public static getConfig():ILayersConfig {
        return {
            BACKGROUND : DungeonQuestLayerConfig.BACKGROUND,
            REEL_BACKGROUND : DungeonQuestLayerConfig.REEL_BACKGROUND,
            NEAR_WIN_DIV_ATTENTIONS : DungeonQuestLayerConfig.NEAR_WIN_DIV_ATTENTIONS,
            REEL_ATTENTIONS : DungeonQuestLayerConfig.REEL_ATTENTIONS,
            BET_LINES : DungeonQuestLayerConfig.BET_LINES,
            PARTICLES_BOTTOM : DungeonQuestLayerConfig.PARTICLES_BOTTOM,
            SYMBOLS : DungeonQuestLayerConfig.SYMBOLS,
            BIG_SYMBOLS : DungeonQuestLayerConfig.BIG_SYMBOLS,
            SYMBOLS_OVERLAY : DungeonQuestLayerConfig.SYMBOLS_OVERLAY,
            DARKEN_PLATE : DungeonQuestLayerConfig.DARKEN_PLATE,
            LOGO_LAYER : DungeonQuestLayerConfig.LOGO_LAYER,
            BIG_WIN : DungeonQuestLayerConfig.BIG_WIN,
            WIN_DISPLAY : DungeonQuestLayerConfig.WIN_DISPLAY,
            RANDOM_WILD_LAYER : DungeonQuestLayerConfig.RANDOM_WILD_LAYER,
            RANDOM_TRANSFORM : DungeonQuestLayerConfig.RANDOM_FEATURE_INTRO,
            PARTICLES_TOP : DungeonQuestLayerConfig.PARTICLES_TOP,
            REEL_FOREGROUND : DungeonQuestLayerConfig.REEL_FOREGROUND,
            DEBUG_OVERLAY : DungeonQuestLayerConfig.DEBUG_OVERLAY,
            INTRO : DungeonQuestLayerConfig.INTRO
        };


    }

}